export default __webpack_public_path__ + "static/media/Splash-Screen-Animation.dc7a9a7e.gif";